module.exports = __webpack_public_path__ + "static/img/hr5.79fdf13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/hr5.jpg
// module id = lwpZ
// module chunks = 0